import { Component, OnInit } from '@angular/core';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-newfndhsyncreport',
  templateUrl: './newfndhsyncreport.component.html',
  
  styleUrls: ['./newfndhsyncreport.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class NewfndhsyncreportComponent implements OnInit {
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  paginator!: MatPaginator;
  isProgressing: Boolean = false;
  filterProperty: any;
  selectedDateStore: any;
  searchBarFilter: boolean;
  today = new Date();
  requestPayload: any;
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  toastr: any;
  totalcount: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  countList:any[];
  filteredList: any[] = [];
  selectedItemDetails: any;
  listData: any[] = [];
  element:any;
  ValSearchDownload: string;
  selectedFRMDate: any = new Date(this.today.setDate(this.today.getDate()));
  displayedColumns: string[] = ['originSystem','totalTransacted','successCount','failureCount'];
  displayedListColumns: string[] = [ 'pmscode', 'fnresnub', 'fxresnub', 'cmresnub', 'resmode',  'resSyncSts', 'reS_SRC', 'reqTKN','reF_ET', ];
  dataSource: MatTableDataSource<any>;
  constructor(private apiCallIdsService: DashboarduiService, private datePipe: DatePipe,private toaster:ToastrService) { }

  ngOnInit() {
    this.isProgressing = true;
    this.GetLoadMethodIDSUser();
  }
  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = true//Indhuja 14-10-2024
  }
  onDateChange(): void {
    // Clear the details table
    this.filteredList = [];
    // Optionally, set other flags or perform additional actions
    this.displayContent = false;
  }
  GetLoadMethodIDSUser() {
    this.selectedFRMDate=this.datePipe.transform(this.selectedFRMDate,'yyyy-MM-dd');
    this.apiCallIdsService.readnewfndhsyncreport(this.selectedFRMDate)
      .subscribe((data) => {
        console.log('Response data:', data);
        if (data && data['count']) {
          this.countList = data['count'];
          this.dataSource = new MatTableDataSource(this.countList);
          //this.dataSource.paginator = this.paginator;
          this.toaster.success('Data Load Successfully');
        } else {
          console.error('No data available');
          this.toaster.error('No Records');
        }
        this.isProgressing = false;
      });
  }
  onTotalTransactedClick(element: any): void {
    this.onDateChange()
    console.log('Clicked on totalTransacted for:', element.originSystem);
    if (element.originSystem === 'Channel Manager' ||element.originSystem==='FX/FD CRS' || element.originSystem==='FN (PMS)') {
      const selectedDateStore = this.datePipe.transform(this.selectedFRMDate, 'yyyy-MM-dd')!;
      this.apiCallIdsService.readnewfndhsyncreport(selectedDateStore).subscribe({
        next: (data) => {
          if (data && data['list']) {
            if(element.originSystem==='FN (PMS)')
            {
              this.listData = data['list'];
              this.filteredList = this.listData.filter(item => item.reS_SRC.toLowerCase() !== 'cm' && item.reS_SRC.toLowerCase() !== 'fxfd'  );
              console.log('Filtered list data for Channel Manager:', this.filteredList);
              this.displayContent = true;
              this.selectedItemDetails = this.filteredList.find(item => item.id === element.id);
              this.toaster.success("Data Load Successfully");
            }
            else if(element.originSystem==='Channel Manager')
            {
              this.listData = data['list'];
              this.filteredList = this.listData.filter(item => item.reS_SRC.toLowerCase() === 'cm' );
              console.log('Filtered list data for Channel Manager:', this.filteredList);
              this.displayContent = true;
              this.selectedItemDetails = this.filteredList.find(item => item.id === element.id);
              this.toaster.success("Data Load Successfully");
            }
            else if(element.originSystem==='FX/FD CRS')
            {
              this.listData = data['list'];
              this.filteredList = this.listData.filter(item => item.reS_SRC.toLowerCase() === 'fxfd');
              console.log('Filtered list data for FX/FD CRS:', this.filteredList);
              this.displayContent = true;
              this.selectedItemDetails = this.filteredList.find(item => item.id === element.id);
              this.toaster.success("Data Load Successfully");
            }
           } else {
            console.error('No list data available');
            this.toaster.error("No Records");
          }
        },
        error: (error) => {
          console.error('Error fetching list data:', error);
        }
      });
    }
    
  }
  onChannelManagerSuccessClick(element: any): void {
    this.onDateChange()
    if (element.originSystem === 'Channel Manager' || element.originSystem === 'FX/FD CRS' || element.originSystem === "FN (PMS)") {
      const selectedDateStore = this.datePipe.transform(this.selectedFRMDate, 'yyyy-MM-dd')!;
      this.apiCallIdsService.readnewfndhsyncreport(selectedDateStore).subscribe({
        next: (data) => {
          if (data && data.list) {
            if (element.originSystem === "FN (PMS)") {
              this.filteredList = data.list.filter((item) => item.reS_SRC.toLowerCase() !== 'fxfd' && item.reS_SRC.toLowerCase() !== 'cm' && item.resSyncSts.toLowerCase().includes('success') && item.isSuccess === 1);
              this.toaster.success("Data Load Successfully")
            } else if (element.originSystem === 'Channel Manager') {
              this.filteredList = data.list.filter((item) => item.reS_SRC.toLowerCase() === 'cm' && item.resSyncSts.toLowerCase().includes('success') && item.isSuccess === 1);
              this.toaster.success("Data Load Successfully")
            } else if (element.originSystem === 'FX/FD CRS') {
              this.filteredList = data.list.filter((item) => item.reS_SRC.toLowerCase() === 'fxfd' && item.resSyncSts.toLowerCase().includes('success') && item.isSuccess === 1);
              this.toaster.success("Data Load Successfully")
            }
            this.displayContent = this.filteredList.length > 0;
          } else {
            console.error('No list data available');
            this.toaster.error("No Records")
          }
        },
        error: (error) => console.error('Error fetching list data:', error),
      });
    }
  }
  onChannelManagerFailureClick(element: any): void {
    this.onDateChange()
    if (element.originSystem === 'Channel Manager' || element.originSystem === 'FX/FD CRS' ||element.originSystem === "FN (PMS)") {
      const selectedDateStore = this.datePipe.transform(this.selectedFRMDate, 'yyyy-MM-dd')!;
      this.apiCallIdsService.readnewfndhsyncreport(selectedDateStore).subscribe({
        next: (data) => {
          if (data && data.list) {
            if (element.originSystem === "FN (PMS)") {
              this.filteredList = data.list.filter((item) => item.reS_SRC.toLowerCase() !== 'fxfd' && item.reS_SRC.toLowerCase().includes('failure') !== 'cm' && item.resSyncSts.toLowerCase().includes('failure') && item.isSuccess === 0);
              this.toaster.success("Data Load Successfully")
            }
            else if(element.originSystem === 'Channel Manager')
            {
              this.filteredList = data.list.filter(
                (item) => item.reS_SRC.toLowerCase() === 'cm' && item.resSyncSts.toLowerCase().includes('failure')&& item.isSuccess===0
              );
              this.toaster.success("Data Load Successfully")
            }
           else if (element.originSystem==='FX/FD CRS') {
            this.filteredList=data.list.filter(
              (item) =>item.reS_SRC.toLowerCase()==='fxfd' && item.resSyncSts.toLowerCase().includes('failure')&& item.isSuccess===0
            );
            this.toaster.success("Data Load Successfully")
           }
            this.displayContent = this.filteredList.length > 0;
          } else {
            console.error('No list data available');
            this.toaster.error("No Records");
          }
        },
        error: (error) => console.error('Error fetching list data:', error),
      });
    }
  }
  formatResSyncSts(value: string): string {
    try {
      const jsonStartIndex = value.indexOf("{");
      if (jsonStartIndex !== -1) {
        const prefix = value.substring(0, jsonStartIndex).trim(); // Extract prefix text
        const jsonString = value.substring(jsonStartIndex); // Extract JSON part
        const parsedData = JSON.parse(jsonString);
  
        // Convert JSON to a readable string (pretty print)
        const formattedJson = JSON.stringify(parsedData, null, 2);
  
        return `${prefix}\n${formattedJson}`;
      }
      // Return the plain value if no JSON is found
      return value;
    } catch (error) {
      console.error("Error formatting resSyncSts:", error);
      return value; // Return the original value if parsing fails
    }
  }
  pageEvent(event: PageEvent) {
    this.filteredList = this.filteredList.slice(event.pageIndex * event.pageSize, (event.pageIndex + 1) * event.pageSize);
  }
}
